import React from "react";

import ExerciseCatalog from "./components/ExerciseCatalog";

const Catalog = (props, { locals }) => {
  return (
    <main className="exercise-catalog">
      <ExerciseCatalog />
    </main>
  );
};

export default Catalog;
